import { SET_INSTAGRAM } from "./types";

export const setInstagram = (payload) => ({
  type: SET_INSTAGRAM,
  payload,
});
